import React, { Component } from "react";
import SideNav from "../Layout/SideNav";
import CastDetail from "../Components/CastDetail";
import * as actions from "../store/actions";
import { API_KEY, API_URL } from "../config";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MovieThumbnailList from "../Components/MovieThumbnailList";

class CastDetailPage extends Component {
  render() {
    return (
      <>
        <SideNav></SideNav>
        <main className="content">
          <CastDetail></CastDetail>
          <div style={{ padding: "6rem 10rem" }}>
            <MovieThumbnailList movies={this.props.castMovies} />
          </div>
        </main>
      </>
    );
  }

  async componentWillMount() {
    const { id } = this.props.match.params;
    let endpoint = `${API_URL}person/${id}?api_key=${API_KEY}&language=en-US`;
    let movieOfThatCast = `${API_URL}person/${id}/movie_credits?api_key=${API_KEY}&language=en-US`;
    this.props.fetchCastInfo(endpoint);
    this.props.fetchCastMovies(movieOfThatCast);
  }
  componentWillUnmount() {
    this.props.cleanData();
  }
}

const mapStateToProps = state => {
  return {
    castInfo: state.castInfo,
    castMovies: state.castMovies
  };
};

export default connect(mapStateToProps, actions)(withRouter(CastDetailPage));
